// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Ubuntu_2a0616', '__Ubuntu_Fallback_2a0616'","fontStyle":"normal"},"className":"__className_2a0616","variable":"__variable_2a0616"};